module.exports = __webpack_public_path__ + "img/service-bg.8d61f7f8.jpg";